import React, { Component } from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';
//import MobileLayout from './MobileLayout/MobileLayout';
//import DesktopLayout from './DesktopLayout/DesktopLayout';
import LangToggle from '../../containers/OptionsHeader/LangToggle/LangToggle';
import { TranslatableText } from '../../providers/LanguageProvider';
import Links from './Links/Links';
import EmailSignup from '../EmailSignup/EmailSignup';
import Social from './Social/Social';

class Footer extends Component {

    state = {
        urlPrefix: '',
        lang: this.props.lang,
        isDesktop: this.props.isDesktop,
        currentYear: new Date()// for footer year
    }

    render() {
        
        return (
            <footer className="footer">
                <div className="footercols">
                    <div className="emailsignupholder">
                        <EmailSignup {...this.props} />
                    </div>
                    <div className="spacer"></div>    
                    <div className="linksholder">
                        <Social />
                        <Links {...this.props} />
                    </div>
                </div>

                <div className="language-selector"><span><Icon type="flag" /><LangToggle {...this.props} /></span></div>

                <div className="termsholder">
                    <Link to={`/${this.props.lang}/terms`}>
                        <TranslatableText dictionary={{
                            en: "Terms",
                            fr: "Conditions" }}>
                        </TranslatableText> 
                    </Link>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <Link to={`/${this.props.lang}/privacy`}>
                        <TranslatableText dictionary={{
                            en: "Privacy Policy",
                            fr: "Politique de confidentialité" }}>
                        </TranslatableText> 
                    </Link>
                </div>

                {this.props.lang === 'en' ? 
                    <p className="copyright"><small>©{this.state.currentYear.getFullYear()} A&W Food Services of Canada Inc.
                    <br />Promotion run by A&W Food Services of Canada Inc., an authorized franchise of Pret A Manger (Europe) Limited.
                    <br />The trademarks that appear are the property of their respective trademark owners.</small>
                    </p>
                    :
                    <p className="copyright"><small>©{this.state.currentYear.getFullYear()} A&W Food Services of Canada Inc.
                    <br />Promotion organisée par Services Alimentaires A&W du Canada Inc., une franchise autorisée de Pret A Manger (Europe) Limited.
                    <br />
                    Les marques de commerce indiquées appartiennent à leur propriétaire respectif.
                    </small>
                    </p>
                }

            </footer>
        );
    }
}

export default Footer;

